// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1026":"f6b273588be99add","1487":"e691b7ea8ffc6635","3057":"164768de0ead1fcd","7472":"bc1c9747581d6016"}[chunkId] + ".js";
};